<template>
    <div class="bottom-waypoint" v-waypoint="{ active: Global.activeWp, callback: BottomWaypoint }"></div>
</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        data() {
            return {
                Global,
                activeRefresh: false
            }
        },

        mounted() {
            // this.$nextTick(() => {this.activeRefresh = true});
        },

        methods: {

            BottomWaypoint ({ el, going, direction }) {

                if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_BOTTOM)
                    this.$emit('enterup')
                if (going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_TOP)
                    this.$emit('exitdown')

            }

        }

    }

</script>